<template>
  <div class="wrapper-content">
    <div class="wrapper">
      <span class="header-icon">
        <font-awesome-icon :icon="['fas', 'users-cog']" />
      </span>
      <h2>Configurações Master</h2>
      <div class="row">
        <div class="col-12 mt-4">
          <b-tabs content-class="mt-3">
            <b-tab
              active
              :title="`${this.$t('menu.masterSettings.titleAllCompanies')}`"
            >
              <master-companies />
            </b-tab>
            <b-tab :title="`${this.$t('menu.masterSettings.titleAllUsers')}`">
              <master-users />
            </b-tab>
            <b-tab :title="`${this.$t('menu.masterSettings.titleReports')}`">
              <master-reports />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterCompanies from './master-companies';
import MasterUsers from './master-users';
import MasterReports from './master-reports';

export default {
  components: { MasterCompanies, MasterUsers, MasterReports },

  data: () => ({
    userAuth: null,
  }),

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    if (this.userAuth.type !== 'master') {
      this.$router.push('404');
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.wrapper-content {
  padding: 8px;
}

.wrapper {
  width: 100%;
  background-color: $white;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid $gray-light;
}
.header-icon {
  float: left;
  font-size: 12px;
  margin-top: 4px;
  padding-right: 12px;
  color: $gray;
}
h2 {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: $gray;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/master/index.vue